import {
  Button,
  Divider,
  Fab,
  FormControl,
  FormControlLabel,
  Grid,
  InputLabel,
  Paper,
  Select,
  Switch,
  TextField,
  Tooltip,
  Typography
} from '@material-ui/core';
import createMuiTheme from '@material-ui/core/styles/createTheme';
/* eslint-disable max-lines-per-function */
import {GetApp, Save, Send} from '@material-ui/icons';
import moment from 'moment';
import PropTypes from 'prop-types';
import React, {Component} from 'react';
import {connect} from 'react-redux';
import locale from '../locale/Localization';
import {addNotifications} from '../store/appActions';
import {
  REGULAR_EXPRESSION_EMAIL,
  REGULAR_EXPRESSION_MOBILE_NUMBER,
  REGULAR_EXPRESSION_POST_CODE,
  USER_TYPE_ADMIN
} from '../utils/constants';
import {getOrDefault} from '../utils/values';
import CompanySearchApp from './CompanySearchApp';
import DatePicker from './DatePicker';

const theme = createMuiTheme();
const styles = {
  root: {flexGrow: 1},
  profilePaper: {
    padding: theme.spacing(3, 2),
    width: 'inherit',
    marginTop: theme.spacing(0.3)
  },
  paper: {padding: theme.spacing(3, 2), width: 'inherit'},
  container: {display: 'flex', flexWrap: 'wrap'},
  gridContainer: {marginTop: theme.spacing()},
  switch: {marginLeft: 10},
  textField: {marginRight: theme.spacing(1), width: 250, marginLeft: 10},
  phoneNumberField: {marginLeft: 10},
  faxNumberField: {marginLeft: -10},
  mobileNumberField: {
    marginRight: theme.spacing(1),
    marginLeft: -30,
    width: 163.33
  },
  dateField: {
    marginRight: theme.spacing(1),
    width: 250,
    marginTop: 4,
    marginLeft: 10
  },
  divider: {margin: '27px -15px 3px -15px'},
  middleTextField: {width: 180, marginRight: theme.spacing(1), marginLeft: 10},
  shortTextField: {width: 50, marginRight: theme.spacing(1), marginLeft: 10},
  formControl: {margin: theme.spacing(1), minWidth: 120},
  inputLabel: {width: '100%'},
  select: {width: 250, marginTop: 24},
  title: {paddingTop: '20px', color: 'white'},
  introText: {paddingBottom: '20px'},
  multiline: {width: 250, marginRight: theme.spacing(1)},
  submitButton: {float: 'right', width: 140},
  subTitle: {paddingTop: '1%', fontWeight: 550, marginLeft: theme.spacing(1)},
  downloadButtonLeft: {float: 'left'},
  downloadButtonRight: {float: 'right', marginRight: theme.spacing(1)}
};
const EMAIL_FIELD = 'email';
const POSTCODE_FIELD = 'postcode';
const INVOICE_POSTCODE_FIELD = 'invoicePostcode';
const MOBILE_NUMBER = 'mobileNumber';

/**
 * Map the properties.
 *
 * @param {*} dispatch
 * @return {Function} - The add user function.
 */
function mapDispatchToProps(dispatch) {
  return {
    addNotifications: (notification) => dispatch(addNotifications(notification))
  };
}

/**
 * Map the state to the properties.
 *
 * @param {Object} state - The state from store.
 * @return {Object} - The state.
 */
const mapStateToProps = (state: Object) => {
  return {user: state.user, roles: state.roles};
};

/**
 * Connected component class of add notary.
 *
 * @return {*} - The functional component.
 */
class ConnectedNotaryForm extends Component {
  // eslint-disable-next-line require-jsdoc
  constructor(props: props) {
    super(props);
    this.notaryDetails = getOrDefault(props.data, {});
    this.state = {
      gender: getOrDefault(this.notaryDetails.gender, ''),
      firstName: getOrDefault(this.notaryDetails.firstName, ''),
      name: getOrDefault(this.notaryDetails.name, ''),
      birthDate: getOrDefault(this.notaryDetails.birthDate, null),
      patentDate: getOrDefault(this.notaryDetails.patentDate, null),
      uid: getOrDefault(this.notaryDetails.uid, ''),
      company: getOrDefault(this.notaryDetails.company, ''),
      street: getOrDefault(this.notaryDetails.street, ''),
      streetNumber: getOrDefault(this.notaryDetails.streetNumber, ''),
      addition: getOrDefault(this.notaryDetails.addition, ''),
      postOffice: getOrDefault(this.notaryDetails.postOffice, ''),
      postcode: getOrDefault(this.notaryDetails.postcode, ''),
      location: getOrDefault(this.notaryDetails.location, ''),
      careOf: getOrDefault(this.notaryDetails.careOf, ''),
      email: getOrDefault(this.notaryDetails.email, ''),
      phoneNumber: getOrDefault(this.notaryDetails.phoneNumber, ''),
      faxNumber: getOrDefault(this.notaryDetails.faxNumber, ''),
      mobileNumber: getOrDefault(this.notaryDetails.mobileNumber, ''),
      exportEmail: getOrDefault(this.notaryDetails.exportEmail, false),
      invoiceCompany: getOrDefault(this.notaryDetails.invoiceCompany, ''),
      invoiceStreet: getOrDefault(this.notaryDetails.invoiceStreet, ''),
      invoiceStreetNumber: getOrDefault(
        this.notaryDetails.invoiceStreetNumber,
        ''
      ),
      invoicePostcode: getOrDefault(this.notaryDetails.invoicePostcode, ''),
      invoiceLocation: getOrDefault(this.notaryDetails.invoiceLocation, ''),
      id: this.notaryDetails.id,
      validateFields: {
        uid: true,
        patentDate: true,
        gender: true,
        firstName: true,
        name: true,
        birthDate: true,
        street: true,
        streetNumber: true,
        postcode: true,
        location: true,
        email: true,
        invoicePostcode: true,
        mobileNumber: true
      },
      validateForm: false,
      isAdmin: props.user.type === USER_TYPE_ADMIN
    };
  }

  /**
   * Validate a input field.
   *
   * @param {string} field - Name of the current input field.
   * @param {*} value - the value.
   */
  validateField = async (field: string, value: *) => {
    const currentValidateFields = this.state.validateFields;
    currentValidateFields[field] =
      this.state[field] !== null && this.state[field] !== undefined;

    if (field === EMAIL_FIELD) {
      currentValidateFields[field] = value.match(REGULAR_EXPRESSION_EMAIL);
    } else if (field === POSTCODE_FIELD || field === INVOICE_POSTCODE_FIELD) {
      currentValidateFields[field] = value.match(REGULAR_EXPRESSION_POST_CODE);
    } else if (field === MOBILE_NUMBER) {
      currentValidateFields[field] = value.match(
        REGULAR_EXPRESSION_MOBILE_NUMBER
      );
    }

    await this.setState({validateFields: currentValidateFields});
  };

  /**
   * Validate the notary form fields.
   *
   * @return {boolean} - The validation result.
   */
  validateFormFields = () => {
    return (
      this.state.birthDate &&
      this.validateDate(this.state.birthDate) &&
      this.state.validateFields.birthDate &&
      this.state.uid &&
      this.state.validateFields.uid &&
      ((this.state.patentDate && this.validateDate(this.state.patentDate)) ||
        this.props.hidePatentDate) &&
      this.state.validateFields.patentDate &&
      this.state.gender &&
      this.state.validateFields.gender &&
      this.state.name &&
      this.state.validateFields.name &&
      this.state.firstName &&
      this.state.validateFields.firstName &&
      this.state.street &&
      this.state.validateFields.street &&
      this.state.streetNumber &&
      this.state.validateFields.streetNumber &&
      this.state.postcode &&
      this.state.validateFields.postcode &&
      this.state.location &&
      this.state.validateFields.location &&
      (this.props.showProfileSubmitButton ||
        this.props.showApplicationSubmitButton ||
        (this.state.email && this.state.validateFields.email))
    );
  };

  /**
   * Checks if the form field is set.
   *
   * @param {any} stateValue - The state of the field.
   * @return {boolean} - The result of the check.
   */
  fieldIsSet = (stateValue: any) => {
    return stateValue ? true : false;
  };

  /**
   * Validate a date input.
   * @param {String} dateString to validate.
   * @return {boolean} validation result
   */
  validateDate(dateString: String) {
    if (dateString === 'Invalid date' || dateString === 'Invalid Date') {
      return false;
    }
    return true;
  }

  /**
   * Handle field changes for different input fields.
   *
   * @param {Event} event - Event from field change action.
   */
  handleFieldChange = async (event: Event) => {
    event.persist();
    const value =
      event.target.name === MOBILE_NUMBER
        ? event.target.value.replaceAll(/\s/g, '')
        : event.target.value;
    await this.setState({[event.target.name]: value});
    await this.validateField(event.target.name, value);
  };

  /**
   * Handle date change for datepicker elements.
   *
   * @param {Date} date - Selected date from user.
   * @param {string} field - Name of the used date picker field.
   */
  handleDateChange = async (date: Date, field: string) => {
    await this.setState({[field]: moment(date).format(locale.dateFormat)});
    await this.validateField(event.target.name, event.target.value);
  };

  /**
   * Handles the submit of the add notary button.
   *
   */
  handleFormSubmit = async () => {
    if (this.validateFormFields()) {
      await this.props.handleSubmit(this.state, this.props.user.id);
    }
  };

  /**
   * Handles the submit of the add notary button.
   *
   */
  handleProfileSubmit = async () => {
    if (this.state.email && this.state.validateFields.email) {
      await this.props.handleProfileSubmit(this.state, this.props.user.id);
    }
  };

  /**
   * Handles the submit of the company search dialog apply button.
   *
   * @param {Object} selectedRow - The data of the selected row.
   */
  handleCompanySearchSubmit = (selectedRow: Object) => {
    this.setState({
      company: selectedRow.name,
      uid: selectedRow.uid,
      street: selectedRow.address.street,
      streetNumber: selectedRow.address.houseNumber,
      postcode: selectedRow.address.swissZipCode,
      location: selectedRow.town
    });
  };

  /**
   * Sub-render method for the form submit button.
   *
   * @return {string} - The component contents.
   */
  renderSubmitButton = () => {
    return (
      !this.state.isAdmin && (
        <Button
          disabled={!this.validateFormFields()}
          variant='contained'
          color='primary'
          size='small'
          style={styles.submitButton}
          onClick={(event) => {
            this.handleFormSubmit(event);
          }}
          startIcon={<Send />}
        >
          {this.props.saveButtonLabel}
        </Button>
      )
    );
  };

  /**
   * Sub-render method for the edit form save and user profile update button.
   *
   * @return {string} - The component contents.
   */
  renderSaveButton = () => {
    return (
      <Button
        disabled={!this.validateFormFields()}
        variant='contained'
        color='primary'
        size='small'
        style={styles.submitButton}
        onClick={(event) => {
          this.handleFormSubmit(event);
        }}
        startIcon={<Save />}
      >
        {this.props.saveButtonLabel}
      </Button>
    );
  };

  /**
   * Renders download button for the signed template document.
   *
   * @return {string} - The button to be rendered.
   */
  renderDocumentDownloadButton = () => {
    const url =
      (this.state.isAdmin ? '/registration/' : '/applications/') +
      this.state.id +
      '/signed-document';
    return (
      <Tooltip title={locale.downloadSignedDocumentButton} placement='top'>
        <Fab
          size='small'
          color='default'
          style={styles.downloadButtonRight}
          href={url}
          target='_blank'
        >
          <GetApp />
        </Fab>
      </Tooltip>
    );
  };

  /**
   * Sub-render method for the user action buttons.
   *
   * @return {string} - The component contents.
   */
  renderUserActionRow = () => {
    return (
      <div>
        <Grid container item xs={12} spacing={3} style={styles.toolbar}>
          <Grid item xs={9}></Grid>
          <Grid item xs={3}>
            {this.props.data &&
              (this.props.showProfileSubmitButton ||
                this.props.showApplicationSubmitButton) &&
              this.renderSubmitButton()}
            {this.props.showDownloadButton &&
              this.renderDocumentDownloadButton()}
            {this.props.showSaveButton && this.renderSaveButton()}
          </Grid>
        </Grid>
      </div>
    );
  };

  /**
   * Sub-render method for the personal information input fields.
   *
   * @return {string} - The component contents.
   */
  // eslint-disable-next-line max-lines-per-function
  renderFirstRow = () => {
    return (
      <div>
        <Grid container item xs={12} spacing={3} style={styles.gridContainer}>
          <Grid item xs={4}>
            <TextField
              disabled={this.props.disableFields}
              required
              error={!this.state.validateFields.firstName}
              helperText={
                !this.state.validateFields.firstName
                  ? locale.requiredFieldHelperText
                  : ''
              }
              margin='dense'
              name='firstName'
              label={locale.firstName}
              type='text'
              style={styles.textField}
              value={this.state.firstName}
              onChange={(event) => {
                this.handleFieldChange(event);
              }}
            />
            <FormControl
              required
              disabled={this.props.disableFields}
              style={styles.formControl}
            >
              <InputLabel htmlFor='gender' style={styles.inputLabel}>
                {locale.gender}
              </InputLabel>
              <Select
                native
                onChange={(event) => {
                  this.handleFieldChange(event);
                }}
                style={styles.select}
                name='gender'
                value={this.state.gender}
                inputProps={{
                  id: 'gender'
                }}
              >
                <option value='' />
                <option value='female'>{locale.female}</option>
                <option value='male'>{locale.male}</option>
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={4}>
            <TextField
              disabled={this.props.disableFields}
              required
              error={!this.state.validateFields.name}
              helperText={
                !this.state.validateFields.name
                  ? locale.requiredFieldHelperText
                  : ''
              }
              margin='dense'
              name='name'
              label={locale.name}
              type='text'
              style={styles.textField}
              value={this.state.name}
              onChange={(event) => {
                this.handleFieldChange(event);
              }}
            />
            {!this.props.hidePatentDate && (
              <DatePicker
                id={'patentDate'}
                label={locale.addNotaryPatentDate}
                handler={this.handleDateChange}
                value={this.state.patentDate}
                required={true}
                disabled={this.props.disableFields}
              />
            )}
          </Grid>
          <Grid item xs={4}>
            <DatePicker
              id={'birthDate'}
              label={locale.birthdate}
              handler={this.handleDateChange}
              value={this.state.birthDate}
              style={styles.dateField}
              margin='dense'
              required={true}
              disabled={this.props.disableFields}
            />
          </Grid>
        </Grid>
      </div>
    );
  };

  /**
   * Sub-render method for the company input fields.
   *
   * @return {string} - The component contents.
   */
  renderSecondRow = () => {
    return (
      <Grid container item xs={12} spacing={0} style={styles.gridContainer}>
        <Grid item xs={4}>
          <CompanySearchApp submitHandler={this.handleCompanySearchSubmit} />
          <TextField
            disabled={this.props.disableFields}
            required
            error={!this.state.validateFields.street}
            helperText={
              !this.state.validateFields.street
                ? locale.requiredFieldHelperText
                : ''
            }
            margin='normal'
            name='street'
            label={locale.addNotaryStreet}
            type='text'
            style={styles.middleTextField}
            value={this.state.street}
            onChange={(event) => {
              this.handleFieldChange(event);
            }}
          />
          <TextField
            disabled={this.props.disableFields}
            required
            error={!this.state.validateFields.streetNumber}
            helperText={
              !this.state.validateFields.streetNumber
                ? locale.requiredFieldHelperText
                : ''
            }
            margin='normal'
            name='streetNumber'
            label={locale.addNotaryNumber}
            type='text'
            style={styles.shortTextField}
            value={this.state.streetNumber}
            onChange={(event) => {
              this.handleFieldChange(event);
            }}
          />
          <TextField
            disabled={this.props.disableFields}
            required
            error={!this.state.validateFields.postcode}
            helperText={
              !this.state.validateFields.postcode ? locale.invalidPostCode : ''
            }
            margin='normal'
            name='postcode'
            label={locale.postcode}
            type='text'
            style={styles.textField}
            value={this.state.postcode}
            onChange={(event) => {
              this.handleFieldChange(event);
            }}
          />
        </Grid>
        <Grid item xs={4}>
          <TextField
            disabled={true}
            required
            error={!this.state.validateFields.uid}
            helperText={
              !this.state.validateFields.uid
                ? locale.requiredFieldHelperText
                : ''
            }
            id='uid'
            name='uid'
            label={locale.uid}
            type='text'
            margin='dense'
            style={styles.textField}
            value={this.state.uid}
            onChange={(event) => {
              this.handleFieldChange(event);
            }}
          />
          <TextField
            disabled={this.props.disableFields}
            margin='normal'
            name='addition'
            value={this.state.addition}
            label={locale.addition}
            type='text'
            style={styles.textField}
            onChange={(event) => {
              this.handleFieldChange(event);
            }}
          />
          <TextField
            disabled={this.props.disableFields}
            required
            error={!this.state.validateFields.location}
            helperText={
              !this.state.validateFields.location
                ? locale.requiredFieldHelperText
                : ''
            }
            margin='normal'
            name='location'
            label={locale.location}
            type='text'
            style={styles.textField}
            value={this.state.location}
            onChange={(event) => {
              this.handleFieldChange(event);
            }}
          />
        </Grid>
        <Grid item xs={4}>
          <TextField
            disabled={this.props.disableFields}
            id='company'
            name='company'
            label={locale.company}
            type='text'
            margin='dense'
            style={styles.textField}
            value={this.state.company}
            onChange={(event) => {
              this.handleFieldChange(event);
            }}
          />
          <TextField
            disabled={this.props.disableFields}
            margin='normal'
            name='postOffice'
            value={this.state.postOffice}
            label={locale.postOffice}
            type='text'
            style={styles.textField}
            onChange={(event) => {
              this.handleFieldChange(event);
            }}
          />
          <TextField
            disabled={this.props.disableFields}
            margin='normal'
            name='careOf'
            value={this.state.careOf}
            label={locale.careOf}
            type='text'
            style={styles.textField}
            onChange={(event) => {
              this.handleFieldChange(event);
            }}
          />
        </Grid>
      </Grid>
    );
  };

  /**
   * Sub-render method for the contact information input fields.
   *
   * @return {string} - The component contents.
   */
  // eslint-disable-next-line max-lines-per-function
  renderThirdRow = () => {
    return (
      <div>
        <Grid container item xs={12} spacing={3} style={styles.gridContainer}>
          <Grid item xs={4}>
            <TextField
              disabled={this.props.disableFields}
              required
              error={!this.state.validateFields.email}
              helperText={
                !this.state.validateFields.email ? locale.invalidEmail : ''
              }
              margin='dense'
              name='email'
              label={locale.emailSecretariat}
              type='email'
              style={styles.textField}
              value={this.state.email}
              onChange={(event) => {
                this.handleFieldChange(event);
              }}
            />
            {this.props.showProfileFields && (
              <FormControlLabel
                labelPlacement='start'
                style={styles.switch}
                control={
                  <Switch
                    checked={this.state.exportEmail}
                    onChange={() =>
                      this.setState({exportEmail: !this.state.exportEmail})
                    }
                    name='exportEmail'
                  />
                }
                label={locale.exportMailToUpreg}
              />
            )}
          </Grid>
          <Grid item xs={3}>
            <TextField
              disabled={this.props.disableFields}
              margin='dense'
              value={this.state.phoneNumber}
              name='phoneNumber'
              label={locale.phoneNumber}
              type='number'
              style={styles.phoneNumberField}
              onChange={(event) => {
                this.handleFieldChange(event);
              }}
            />
          </Grid>
          <Grid item xs={3}>
            <TextField
              disabled={this.props.disableFields}
              margin='dense'
              name='faxNumber'
              value={this.state.faxNumber}
              label={locale.faxNumber}
              type='number'
              style={styles.faxNumberField}
              onChange={(event) => {
                this.handleFieldChange(event);
              }}
            />
          </Grid>
          <Grid item xs={2}>
            <TextField
              disabled={this.props.disableFields}
              error={!this.state.validateFields.mobileNumber}
              helperText={
                !this.state.validateFields.mobileNumber
                  ? locale.invalidMobileNumber
                  : ''
              }
              placeholder={locale.mobilNumberPlaceHolder}
              margin='dense'
              value={this.state.mobileNumber}
              name='mobileNumber'
              label={locale.mobileNumber}
              type='text'
              style={styles.mobileNumberField}
              onChange={(event) => {
                this.handleFieldChange(event);
              }}
            />
          </Grid>
        </Grid>
      </div>
    );
  };

  renderInvoiceAddress = () => {
    const requireInvoiceFields =
      this.fieldIsSet(this.state.invoiceCompany) ||
      this.fieldIsSet(this.state.invoiceStreet) ||
      this.fieldIsSet(this.state.invoiceStreetNumber) ||
      this.fieldIsSet(this.state.invoicePostcode) ||
      this.fieldIsSet(this.state.invoiceLocation);
    return (
      <div>
        <Typography variant='subtitle1' gutterBottom style={styles.subTitle}>
          {locale.invoiceAddress}
        </Typography>
        <Grid container item xs={12} spacing={3}>
          <Grid item xs={4}>
            <TextField
              disabled={this.props.disableFields}
              required={requireInvoiceFields}
              id='invoiceCompany'
              name='invoiceCompany'
              label={locale.company}
              type='text'
              margin='dense'
              style={styles.textField}
              value={this.state.invoiceCompany}
              onChange={(event) => {
                this.handleFieldChange(event);
              }}
            />
            <TextField
              disabled={this.props.disableFields}
              required={requireInvoiceFields}
              error={!this.state.validateFields.invoicePostcode}
              helperText={
                !this.state.validateFields.invoicePostcode
                  ? locale.invalidPostCode
                  : ''
              }
              margin='normal'
              name='invoicePostcode'
              label={locale.postcode}
              type='text'
              style={styles.textField}
              value={this.state.invoicePostcode}
              onChange={(event) => {
                this.handleFieldChange(event);
              }}
            />
          </Grid>
          <Grid item xs={4}>
            <TextField
              disabled={this.props.disableFields}
              required={requireInvoiceFields}
              error={!this.state.validateFields.street}
              helperText={
                !this.state.validateFields.street
                  ? locale.requiredFieldHelperText
                  : ''
              }
              margin='dense'
              name='invoiceStreet'
              label={locale.addNotaryStreet}
              type='text'
              style={styles.middleTextField}
              value={this.state.invoiceStreet}
              onChange={(event) => {
                this.handleFieldChange(event);
              }}
            />
            <TextField
              disabled={this.props.disableFields}
              required={requireInvoiceFields}
              error={!this.state.validateFields.streetNumber}
              helperText={
                !this.state.validateFields.streetNumber
                  ? locale.requiredFieldHelperText
                  : ''
              }
              margin='dense'
              name='invoiceStreetNumber'
              label={locale.addNotaryNumber}
              type='text'
              style={styles.shortTextField}
              value={this.state.invoiceStreetNumber}
              onChange={(event) => {
                this.handleFieldChange(event);
              }}
            />
            <TextField
              disabled={this.props.disableFields}
              required={requireInvoiceFields}
              error={!this.state.validateFields.location}
              helperText={
                !this.state.validateFields.location
                  ? locale.requiredFieldHelperText
                  : ''
              }
              margin='normal'
              name='invoiceLocation'
              label={locale.location}
              type='text'
              style={styles.textField}
              value={this.state.invoiceLocation}
              onChange={(event) => {
                this.handleFieldChange(event);
              }}
            />
          </Grid>
          <Grid item xs={4}></Grid>
        </Grid>
      </div>
    );
  };

  /**
   * React render function.
   *
   * @return {string} - The component contents.
   */
  render() {
    return (
      <div id='root' style={styles.root}>
        <Typography variant='h5' gutterBottom style={styles.title}>
          {this.props.headline ? this.props.headline : ''}
        </Typography>
        <Typography variant='body1' gutterBottom style={styles.introText}>
          {this.notaryDetails ? '' : locale.addNotaryIntro}
        </Typography>
        <Paper style={styles.paper}>
          {this.props.showUserActionRow && this.renderUserActionRow()}
          {this.renderFirstRow()}
          <Divider style={styles.divider} />
          {this.renderSecondRow()}
        </Paper>
        <Paper style={styles.profilePaper}>
          <Grid container item xs={12} spacing={3}>
            <Grid item xs={12}>
              {this.props.showProfileSaveButton && (
                <Button
                  disabled={
                    !(this.state.email && this.state.validateFields.email)
                  }
                  variant='contained'
                  color='primary'
                  size='small'
                  style={styles.submitButton}
                  onClick={() => {
                    this.handleProfileSubmit(this.state);
                  }}
                  startIcon={<Save />}
                >
                  {locale.saveButton}
                </Button>
              )}
            </Grid>
          </Grid>
          {this.renderThirdRow()}
          {this.props.showProfileFields && this.renderInvoiceAddress()}
        </Paper>
      </div>
    );
  }
}

ConnectedNotaryForm.propTypes = {
  addNotifications: PropTypes.func.isRequired,
  exportEmail: PropTypes.bool,
  handleSubmit: PropTypes.func,
  handleProfileSubmit: PropTypes.func,
  data: PropTypes.object,
  headline: PropTypes.string,
  roles: PropTypes.array.isRequired,
  user: PropTypes.object.isRequired,
  hidePatentDate: PropTypes.bool,
  showProfileFields: PropTypes.bool,
  showApplicationSubmitButton: PropTypes.bool,
  showProfileSaveButton: PropTypes.bool,
  showProfileSubmitButton: PropTypes.bool,
  showDownloadButton: PropTypes.bool,
  showUserActionRow: PropTypes.bool,
  showSaveButton: PropTypes.bool,
  disableFields: PropTypes.bool,
  saveButtonLabel: PropTypes.string
};

const NotaryForm = connect(
  mapStateToProps,
  mapDispatchToProps
)(ConnectedNotaryForm);
export default NotaryForm;
